import { render } from "./LangSwitch.vue?vue&type=template&id=e8926e8e"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"

import "./LangSwitch.vue?vue&type=style&index=0&id=e8926e8e&lang=css"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__